import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import Banner1 from '../../assets/image/female-manager-with-client.jpg'
import {FormControl,RadioGroup,FormControlLabel,Radio,Checkbox,TextField,Button,CircularProgress } from '@material-ui/core'
import {URL,USER,PASS} from '../../service/base_url'
import Modal from '../../components/modal'
import axios from 'axios'
import {get} from 'lodash'
export default class index extends Component {
    state={
        services:'learning',
        name:'',
        phoneNumber:'',
        email:'',
        companyName:'',
        message:'',
        loading:false,
        success_form:false
    }
    onChange=(e)=>{
        // console.log(e.target.name,e.target.value)
        e.preventDefault()
        this.setState({[e.target.name]:e.target.value})
    }
    submit=(e)=>{
        e.preventDefault()
        this.setState({loading:true})
        let {name,phoneNumber,email,companyName,message,services}=this.state
        axios.post(`${URL}`,{
            name,phoneNumber,email,companyName,action:`schedule-${services}`,message
        },{
            auth: {
                username: USER,
                password: PASS
              }
        }).then((res)=>{
            if(get(res,'status')==200){
                this.setState({loading:false})

                this.setState({success_form:!this.state.success_form})
            }else{
                this.setState({loading:false})
                alert('Ops something error')
            }
        })
    }
    toggleSucces=()=>{
        this.setState({success_form:!this.state.success_form})
    }
    children2=()=>{
        return(
            <div>
                <p>Thank you for your interest in One GML. we will contact you as soon as possible</p>
                <br/>
                <Button onClick={()=>window.location.assign('/')} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Ok</Button>
            </div>
        )
    }
    render() {
        let {loading,success_form}=this.state
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <Modal title="We received your message" isOpen={success_form} children={this.children2()} modalToggle={this.toggleSucces}/>
                <div className='meeting-wrap'>
                <section className='meeting'>
                    <div className='form'>
                        <h1>Let’s arrange our meeting</h1>
                        <br/>
                        <p>Thank you for your interest in One GML. Please fill out the form below to ask a question. Required fields are marked with an asterisk (*).</p>
                        <br/>
                        <h4>What services are you interested in?</h4>
                        <br/>
                        <form onSubmit={this.submit}>
                        <FormControl component="fieldset" className='form-controll'>
                        <RadioGroup required value={this.state.services} aria-label="gender" onChange={(e)=>this.setState({services:e.target.value})} name="gender2"  >
                        <FormControlLabel
                            value="Strategy and Organization"
                            control={<Checkbox color="primary" />}
                            label="Strategy and Organization"
                            name='services'
                            onChange={this.onChange}
                        />
                        <FormControlLabel
                            value="learning"
                            control={<Checkbox color="primary" />}
                            label="Learning"
                            name='services'
                            onChange={this.onChange}
                        />
                        <FormControlLabel
                            value="event"
                            control={<Checkbox color="primary" />}
                            label="Event Management"
                            name='services'
                            onChange={this.onChange}
                        />
                        <FormControlLabel
                            value="assestment_center"
                            control={<Checkbox color="primary" />}
                            label="Assesment center"
                            name='services'
                            onChange={this.onChange}
                        />
                        <FormControlLabel
                            value="digital_learning"
                            control={<Checkbox color="primary" />}
                            label="Digital learning"
                            name='services'
                            onChange={this.onChange}
                        />
                        
                        </RadioGroup>
                        <br/>
                        <TextField
                            // label="Name"
                            label={<p>Name<span style={{color:'#78000f'}}>*</span></p>}
                            variant="outlined"
                            size="small"
                            className='form-meeting'
                            name='name'
                            onChange={this.onChange}
                            
                        />
                        <TextField
                            // label="Handphone No."
                            label={<p>Phone No.<span style={{color:'#78000f'}}>*</span></p>}
                            variant="outlined"
                            size="small"
                            className='form-meeting'
                            name='phoneNumber'
                            onChange={this.onChange}
                            
                        />
                        <TextField
                            // label="Email"
                            label={<p>Email<span style={{color:'#78000f'}}>*</span></p>}
                            variant="outlined"
                            size="small"
                            className='form-meeting'
                            name='email'
                            onChange={this.onChange}
                            
                            type="email"
                        />
                        <TextField
                            // label="Company name"
                            label={<p>Company name<span style={{color:'#78000f'}}>*</span></p>}
                            variant="outlined"
                            size="small"
                            className='form-meeting'
                            name='companyName'
                            onChange={this.onChange}
                            
                        />
                        <TextField
                            // label="Message"
                            label={<p>Message<span style={{color:'#78000f'}}>*</span></p>}
                            variant="outlined"
                            size="small"
                            multiline
                            className='form-meeting'
                            name='message'
                            onChange={this.onChange}
                            rows="4"
                            
                        />
                         {/* <TextField
                            // label="Meeting date"
                            label={<p>Meeting date<span style={{color:'red'}}>*</span></p>}
                            variant="outlined"
                            size="small"
                            className='form-meeting'
                            defaultValue="2017-05-24T10:30"
                            type="datetime-local"
                        /> */}
                        <Button type='submit' style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">
                        {loading? <CircularProgress size={20} style={{color:'white'}}/>:'Send'}
                        </Button>
                    </FormControl>
                    </form>
                    </div>
                    <div className='banner-img-meeting' style={{textAlign:'center'}}>
                    <div className="dot"></div>
                        <div className="image1">
                            <img src={Banner1} className='banner-slider-meeting'/>
                        </div>
                        <div className='sadow'></div>
                       
                    </div>

                </section>
                </div>
                <br/><br/>
                <Footer/>

            </div>
        )
    }
}
